// document.addEventListener('DOMContentLoaded', function () {
//   // This function will be executed when the DOM is ready.
//   Vue.use(Vuex) // (i) You don't need to do this when using global script tags.
// })

// Vue.use(Vuex) // (i) You don't need to do this when using global script tags.
//Vue.config.productionTip = false

Vue.component('vue-slick-carousel', window['vue-slick-carousel']);

Vue.component('v-select', VueSelect.VueSelect);
Vue.component('v-chart', VueECharts);

//

var mainApp = new Vue({
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	el: '#main-app',
	store: vStore,
	i18n,
	data: {
		message: 'Hi Web',
		windowInnerWidth: window.innerWidth,
	},
	mounted() {
		appLog.log(vStore);
		appLog.log(this.$store);
		this.$store.dispatch('sayHi');
		appLog.log(this.$t('mainMenu.hello'));
		//this.$store.dispatch('navBar/sayHi')

		appLog.log(this.$store.state.navBar.me);
		appLog.log(this.$store.state.navBar.sandBox);
		appLog.log(this.$store.getters['navBar/me']);
		this.$store.commit('navBar/setSandBox', 'This is sand');
		appLog.log(this.$store.state.navBar.sandBox);
		appLog.log(this.$store.getters['userPath']);
		this.$store.dispatch('setUserPathToLab');
		appLog.log(this.$store.getters['localization/shopUserLocalization']);
		this.setCurrencyCode(this.$store.getters['localization/shopUserLocalization'].currencyCode);
		// this.setCountryCode('TW')
		//this.$store.getters['localization/shopUserLocalization'].countryCode
		appLog.log(this.$store.getters['localization/shopUserLocalization'].countryCode);
		appLog.log(this.$store.getters['localization/shopCountriesArray']);
		window.addEventListener('resize', this.handleResize);

		this.$store.dispatch('scrollToTop');

		this.setStoreIsMobile(this.isMobile);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleResize);
	},
	computed: {
		...Vuex.mapGetters(['pageIsLoading']),
		// ...Vuex.mapGetters('articles', ['articlesArray']),
		userPath() {
			return this.$store.getters['userPath'];
		},

		isMobile() {
			let width = this.windowInnerWidth;

			// if we are in mobile // = 791
			if (width < 900) {
				return true;
			} else {
				return false;
			}
		},
	},
	methods: {
		...Vuex.mapActions(['setStoreIsMobile']),
		...Vuex.mapActions('localization', ['setCurrencyCode', 'setCountryCode']),
		// ...Vuex.mapActions('articles', ['getLastArticles']),
		changeToClinic() {
			this.$store.dispatch('setUserPathToClinic');
		},

		handleResize() {
			this.windowInnerWidth = window.innerWidth;
		},
	},
	watch: {
		isMobile: {
			handler() {
				// update isMobile on store
				this.setStoreIsMobile(this.isMobile);
			},
			deep: false,
		},
	},
});
